<template>
<div class="short-page" v-if="success">
  <ui-alert :dismissible="false">Zostałeś wylogowany! Miłego dnia</ui-alert>
  <panel>
    <p slot="header">Wylogowano poprawnie</p>

    <ui-button color="primary" @click="goLogin">Zaloguj sie ponownie</ui-button>
  </panel>
</div>
</template>
<script>
import Auth from './../../services/Auth'

export default {
  data () {
    return {
      success: false
    }
  },
  mounted () {
    this.doLogout()
  },
  methods: {
    goLogin () {
      this.$router.push({
        name: 'login'
      })
    },
    doLogout () {
      Auth.clearToken()
      this.success = true
    }
  }
}

</script>


// WEBPACK FOOTER //
// Logout.vue?3b419393